import { client } from "../supabase";
import { buildContextoCobro, buildCobroPorVenta } from "./getCobroFactura";

/**
 * Carga el libro de cobro (`aplicaciones_saldo`, fuente única — regla 10.190) + el conector
 * venta↔factura SII, y devuelve el mapa `cobroPorVenta` keyado por `refKeyDeVinculacion` (L6 tramo 4:
 * `linea:<linea_id>` para cartelería/hardware, `${venta_tipo}:${venta_ref_id}:${venta_ref_index??""}`
 * para pauta/BTL/contratos — ver `src/utils/lineasFacturacion/refKey.js`).
 *
 * Es la fuente de "recaudada" para el motor de comisión de edificios (sales + sales_contratos),
 * que antes leía `sales.facturafechacobro` crudo (que el cobro SII nunca puebla → facturas
 * cobradas figuraban Pendiente, Bug B). Resuelve la cobranza a nivel factura SII (uniforme para
 * los 4 modelos) y la expone por venta para que el motor la consuma sin reescribir su lógica.
 */
export const cargarCobroPorVenta = async (pais) => {
  const [vinc, fact, libro] = await Promise.all([
    client
      .from("facturas_sii_vinculaciones")
      .select("venta_tipo, venta_ref_id, venta_ref_index, linea_id, factura_sii_emitida_id"),
    // moneda: la necesita el resolver para la tolerancia por moneda (misma vs cross-currency).
    client.from("facturas_sii_emitidas").select("id, monto_total, moneda").eq("pais", pais),
    // Libro de cobro (fuente única, regla 10.190). getCobroReal delega en resolverSaldo sobre esto.
    client
      .from("aplicaciones_saldo")
      .select("documento_tipo, documento_id, via, monto_documento, moneda_origen, fecha_evento")
      .eq("documento_tipo", "sii_emitida"),
  ]);

  const ctx = buildContextoCobro({
    aplicacionesSaldo: libro.data || [],
    facturasEmitidas: fact.data || [],
  });

  // Solo vinculaciones cuya factura es de este país (las demás resolverían a no-cobrada por no
  // estar en el ctx; se descartan para no ensuciar el mapa con keys de otros países).
  const idsPais = new Set((fact.data || []).map((f) => f.id));
  const vinculaciones = (vinc.data || []).filter((v) => idsPais.has(v.factura_sii_emitida_id));

  return buildCobroPorVenta(vinculaciones, ctx);
};
